/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Filter_Bank_SourcedInputs */

const vi_expense_filter_bank_sourced = /** @type {(inputs: Expense_Filter_Bank_SourcedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từ sao kê ngân hàng`)
};

/**

* @param {Expense_Filter_Bank_SourcedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_filter_bank_sourced = /** @type {((inputs?: Expense_Filter_Bank_SourcedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Filter_Bank_SourcedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_filter_bank_sourced(inputs)
});